import React, { useState } from 'react';
import { useStoreLazyQuery } from '../graphql/queries/storeAdminInfo.generated';
import { useCreateCheckoutsMutation } from '../graphql/mutations/createCheckouts.generated';
import { LayoutStoreInstance } from '../LayoutStore';
import i18n from '@/utils/i18n';

export default function CreateCheckouts() {
  const [storeId, setStoreId] = useState<string | null>(null);
  const [count, setCount] = useState<number>(0);
  const [disabled, setDisabled] = useState<boolean>(false);

  const [storeInfoLazyQuery] = useStoreLazyQuery({
    variables: { id: storeId || '' },
    fetchPolicy: 'no-cache',
  });

  const [createCheckoutsMutation] = useCreateCheckoutsMutation();

  async function handleClick() {
    if (storeId && count) {
      const data = await storeInfoLazyQuery();
      const name = data.data?.store?.name;
      if (data.data?.store?.external_vytal_id == null) {
        alert(i18n.t('Common:storeNoExternalIdError', { name }));
      } else {
        const confirmation = prompt(
          i18n.t('Common:confirmCreateCheckouts', { count, name }),
        );
        if (confirmation === count.toString()) {
          const result = await createCheckoutsMutation({
            variables: {
              store_id: data.data?.store?.external_vytal_id || '',
              count: count,
            },
          });
          console.log(result);
          if (result.data?.createCheckouts !== true || result.errors != null) {
            console.log('if');
            LayoutStoreInstance.setError(
              i18n.t('Common:failedToCreateCheckouts'),
            );
          } else {
            console.log('else');
            setDisabled(true);
            LayoutStoreInstance.setSuccess(
              i18n.t('Common:successfullyCreatedCheckouts'),
            );
          }
        }
      }
    }
  }

  return (
    <div>
      <h2>{i18n.t('Common:createCheckoutsTitle')}</h2>
      <div className="input-group mb-3">
        <span className="input-group-text" id="basic-addon1">
          {i18n.t('Common:storeIdLabel')}
        </span>
        <input
          type="text"
          className="form-control"
          name="delivery_address.first_name"
          onChange={(e) => setStoreId(e.target.value)}
          value={storeId || ''}
        />
      </div>
      <div className="input-group mb-3">
        <span className="input-group-text" id="basic-addon1">
          {i18n.t('Common:checkoutCountLabel')}
        </span>
        <input
          type="text"
          className="form-control"
          name="delivery_address.first_name"
          onChange={(e) => setCount(parseInt(e.target.value))}
          value={count}
        />
      </div>
      <button
        className="form-control"
        disabled={disabled}
        onClick={handleClick}
      >
        {i18n.t('Common:createCheckoutsButton', { count })}
      </button>
    </div>
  );
}
